import { cn } from '@/utils/cn';

interface CompanyTagProps {
	companyName: string;
}

function getCompanyTagColors(companyName: string): string {
	switch (companyName) {
		case 'TAMAC':
			return 'bg-[#83abd08a] text-[#222a84]';
		case 'UTE':
			return 'bg-[#4A6FA5] text-[#E1E9F2]';
		case 'ORIGEM ENERGIA':
		default:
			return 'bg-[#E9F1FF] text-[#1826BD]';
	}
}

export const CompanyTag = ({ companyName }: CompanyTagProps) => {
	return (
		<div
			className={cn(
				'mr-2 h-8 min-w-20 rounded p-2 text-[12px]',
				getCompanyTagColors(companyName),
			)}
		>
			{`Empresa: ${companyName}`}
		</div>
	);
};
